import type { ReactNode } from 'react';

/** Eyebrow section heading with optional right-aligned action. */
export function SectionLabel({ children, action }: { children: ReactNode; action?: ReactNode }) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: 12,
      }}
    >
      <span className="eyebrow">{children}</span>
      {action}
    </div>
  );
}
